<template>
  <section class="profile-tab">
    <section
      v-if="showInfo"
      class="profile-info">
      <h1>Profile</h1>
      <div class="top-right">
        <v-button
          size="small"
          @click="handlerEdit"
        >Edit Profile
        </v-button>
      </div>

      <div class="status-container">
        <div
          v-if="showReviewIdentification"
          class="waiting-bar">
          <span>The identification document of this account is waiting approval.</span>
          <v-button @click="$emit('review')">Review</v-button>
        </div>
      </div>


      <div class="box">
        <div class="table-box user-info">
          <div class="title">
            <span>User Info</span>
          </div>
          <template v-if="formData.identity == 1">
            <div class="tr">
              <span>Title</span>
              <span
                v-if="formData.isrd_title != 0"
              >{{ formData.isrd_title_language }}
                <font-awesome-icon
                  v-if="isVerified && formData.isrd_title_language"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div class="tr">
              <span>Last Name</span>
              <span>
                {{ formData.isrd_lst_nm}}
                <font-awesome-icon
                  v-if="isVerified"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div class="tr">
              <span>First Name</span>
              <span>
                {{ formData.isrd_fst_nm}}
                <font-awesome-icon
                  v-if="isVerified"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div class="tr">
              <span>Date of Birth</span>
              <span
              >{{ formData.isrd_dob_date }}
                <font-awesome-icon
                  v-if="isVerified"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div class="tr">
              <span>Identification</span>
              <span v-if="formData.id_type">
                {{ formData.id_type == 1 ? "HKID" : "Passport"}}
                <font-awesome-icon
                  v-if="isVerified"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>

            <template v-if="formData.id_type == 1">
              <div class="tr">
                <span>HKID</span>
                <span>
                  <div class="flex middle">
                    <span>
                      {{ formData.id_no}}
                      <font-awesome-icon
                        v-if="isVerified"
                        icon="check-circle"
                        class="check icon"></font-awesome-icon>
                    </span>
                    <div
                      v-if="!isVerified"
                      class="approveStatus"
                    >Waiting Approval</div
                    >
                  </div>
                </span>
              </div>
              <div class="tr">
                <span>HKID File</span>
                <span>
                  <div
                    v-if="photoUrl"
                    class="upload-card">
                    <!-- <img
                      v-if="photoUrl"
                      :src="photoUrl"
                      alt="" /> -->
                    <v-upload
                      disabled
                      card
                      noBorder
                      widthFull
                      :fileData="{
                        url: photoUrl('url'),
                        thumb_url: photoUrl('thumb_url'),
                      }"></v-upload>
                  </div>
                </span>
              </div>
            </template>
            <template v-if="formData.id_type == 2">
              <div class="tr">
                <span>Passport</span>
                <span>
                  <div class="flex middle">
                    <span>
                      {{ formData.pp_no}}
                      <font-awesome-icon
                        v-if="isVerified"
                        icon="check-circle"
                        class="check icon"></font-awesome-icon>
                    </span>
                    <div
                      v-if="!isVerified"
                      class="approveStatus"
                    >Waiting Approval</div
                    >
                  </div>
                </span>
              </div>
              <div class="tr">
                <span>Nationality</span>
                <span>
                  {{ formData.id_nationality_seq_language}}
                  <font-awesome-icon
                    v-if="isVerified"
                    icon="check-circle"
                    class="check icon"></font-awesome-icon>
                </span>
              </div>
              <div class="tr">
                <span>Passport File</span>
                <span>
                  <div
                    v-if="photoUrl"
                    class="upload-card">
                    <!-- <img
                      v-if="photoUrl"
                      :src="photoUrl"
                      alt="" /> -->
                    <v-upload
                      disabled
                      card
                      noBorder
                      widthFull
                      :fileData="{
                        url: photoUrl('url'),
                        thumb_url: photoUrl('thumb_url'),
                      }"></v-upload>
                  </div>
                </span>
              </div>
            </template>
            <div class="tr">
              <span>Mobile No.</span>
              <span>
                {{ formData.phone }}
                <font-awesome-icon
                  v-if="formData.phone"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div class="tr email">
              <span>Email</span>

              <template v-if="!formData.draft_email">
                <span>
                  {{ formData.email }}
                  <email-tooltip :email="formData.email"></email-tooltip>
                  <font-awesome-icon
                    v-if="formData.email"
                    icon="check-circle"
                    class="check icon"></font-awesome-icon>
                </span>
              </template>
              <template v-else>
                <div class="column-box">
                  <div
                    v-if="formData.email"
                    class="mt-5">
                    {{ formData.email }}
                    <email-tooltip :email="formData.email"></email-tooltip>
                    <font-awesome-icon
                      icon="check-circle"
                      class="check icon"></font-awesome-icon>
                  </div>
                  <div class="mt-5">
                    {{ formData.draft_email }}
                    <email-tooltip :email="formData.draft_email"></email-tooltip>
                    <span class="status">
                      <font-awesome-icon
                        icon="warning"
                        class="icon"></font-awesome-icon>
                      Unverified
                    </span>
                  </div>
                  <div class="btnList mt-5">
                    <v-button
                      class="send"
                      :class="{'gray': sendBtnDisabled}"
                      :disabled="sendBtnDisabled"
                      @click="sendVerification">
                      <span class="label-name">Send verification</span>
                      <span
                        v-if="sendBtnDisabled"
                        class="second">{{seconds}}s</span>
                    </v-button>
                    <v-button
                      v-if="formData.email"
                      class="cancel"
                      @click="draftEmailCancel">Cancel</v-button>
                  </div>
                </div>
              </template>
            </div>
            <!-- <div class="tr">
            <span> Occupation <br />and Job <br />Nature</span>
            <span>{{ getAllOptionName("occupation", formData.occ_id) }}</span>
          </div> -->
            <div class="tr">
              <span>Address</span>
              <span> {{ address }}</span>
            </div>
          </template>
          <template v-else>
            <div class="tr">
              <span>Company Name</span>
              <span
              >{{ formData.isrd_com_nm }}
                <font-awesome-icon
                  v-if="isVerified"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div
              v-if="!formData.attached_account"
              class="tr">
              <span>Company Email</span>
              <span class="column">
                <div> {{ formData.email }}
                  <email-tooltip :email="formData.email"></email-tooltip>
                  <font-awesome-icon
                    icon="check-circle"
                    class="check icon"></font-awesome-icon>
                </div>
                <div
                  v-if="formData.attached_change_account"
                  class="flex resend-email">
                  <span class="italic">{{formData.attached_change_account}}</span>
                  <span ><v-button
                    class="send-btn"
                    @click="handleMultiSend">Resend Email</v-button></span>
                </div>
              </span>
            </div>
            <template v-if="formData.attached_account">
              <div class="tr">
                <span>Company Email</span>
                <span class="column purple">
                  <div class="flex flex-exist-link">
                    <font-awesome-icon
                      icon="link"
                      class="icon"></font-awesome-icon>
                    <div>{{ formData.email }}</div>
                    <email-tooltip :email="formData.email"></email-tooltip>
                  </div>
                  <span
                    class="flex flex-email"
                    @click="handleShowEmail">
                    <span>
                      {{ formData.attached_accounts.length }} linked account</span>
                    <font-awesome-icon
                      icon="angle-right"
                      class="icon-right icon"></font-awesome-icon>
                  </span>
                  <span
                    v-if="formData.attached_change_account"
                    class="flex resend-email">
                    <span class="italic">{{formData.attached_change_account}}</span>
                    <span ><v-button
                      class="send-btn"
                      @click="handleMultiSend">Resend Email</v-button></span>
                  </span>


                </span>
              </div>
            </template>
            <!--          <div-->
            <!--            v-if="formData.contact_nm"-->
            <!--            class="tr">-->
            <!--            <span>Contact Name</span>-->
            <!--            <span>{{ formData.contact_nm }}-->
            <!--              <i-->
            <!--                v-if="isVerified"-->
            <!--                class="el-icon-check check"/>-->
            <!--            </span>-->
            <!--          </div>-->
            <!-- <div class="tr">
            <span>Contact Person First Name</span>
            <span>{{ formData.contact_fst }}
              <i
                v-if="isVerified"
                class="el-icon-check check"/>
            </span>
          </div>

          <div
            class="tr">
            <span>Contact Person Last Name</span>
            <span>{{ formData.contact_lst }}
              <i
                v-if="isVerified"
                class="el-icon-check check"/>
            </span>
          </div> -->
            <div class="tr">
              <span>Business Registration Number</span>
              <span>
                <div class="flex middle">
                  <div>
                    {{ formData.id_no}}
                    <font-awesome-icon
                      v-if="isVerified"
                      icon="check-circle"
                      class="check icon"></font-awesome-icon>
                  </div>
                  <div
                    v-if="!isVerified"
                    class="approveStatus"
                  >Waiting Approval</div
                  >
                </div>
              </span>
            </div>
            <div class="tr">
              <span>Company Phone Number</span>
              <span
              >{{ formData.phone_no }}
              </span>
            </div>
            <div class="tr">
              <span>Nature of Business</span>
              <span>
                {{ formData.bsns_nature}}
                <font-awesome-icon
                  v-if="isVerified"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div class="tr">
              <span>Business Registration Certification</span>
              <span>
                <div
                  v-if="photoUrl"
                  class="upload-card">
                  <!-- <img
                    v-if="photoUrl"
                    :src="photoUrl"
                    alt="" /> -->
                  <v-upload
                    disabled
                    card
                    noBorder
                    widthFull
                    :fileData="{
                      url: photoUrl('url'),
                      thumb_url: photoUrl('thumb_url'),
                    }"></v-upload>
                </div>
              </span>
            </div>
            <!--          <div class="tr">-->
            <!--            <span>Contact Person Occupation</span>-->
            <!--            <span-->
            <!--            >{{ getOptionName('allOptions.occupation',formData.contact_occ_id )}}-->
            <!--              <i-->
            <!--                v-if="isVerified"-->
            <!--                class="el-icon-check check" />-->
            <!--            </span>-->
            <!--          </div>-->
            <!--          <div class="tr">-->
            <!--            <span>Contact Person Email</span>-->
            <!--            <span-->
            <!--            >{{ formData.contact_email }}-->
            <!--              <i-->
            <!--                v-if="formData.contact_email"-->
            <!--                class="el-icon-check check" />-->
            <!--            </span>-->
            <!--          </div>-->


            <div class="tr">
              <span>Address</span>
              <span>
                {{ address }}
              </span>
            </div>
          </template>

          <div
            v-if="formData.ali_open_id"
            class="tr">
            <span>AlipayHK Linked ID</span>
            <span class="ali_id">
              {{ formData.ali_open_id }}
              <span
                class="unlink"
                @click="handleUnlink">Unlink</span>
            </span>
          </div>

          <div class="tr">
            <span>Language</span>
            <span>{{ formData.language }}</span>
          </div>

          <div class="tr">
            <span>Communications Preference</span>
            <span>Marketing Communications: {{ formData.is_comm_sub == 1? 'On' : 'Off' }}</span>
          </div>
        </div>

        <div class="table-box">
          <div
            class="title hd"
            @click="handleToHD">
            <span class="title-name">Hold Dollars</span>
            <span class="money">{{formData.money}}</span>
            <font-awesome-icon
              icon="angle-right"
              class="icon"></font-awesome-icon>
            <span class="code">Refer Code: {{formData.code}}</span>
          </div>
        </div>

        <div
          v-if="formData.identity == 2"
          class="table-box">
          <div class="title">
            <span>Contact Person</span>
          </div>
          <div class="tr">
            <span>Name</span>
            <span>{{ formData.contact_nm }}</span>
          </div>
          <div class="tr">
            <span>Occupation & Position</span>
            <span>{{ formData.contact_occ }}</span>
          </div>
          <div class="tr">
            <span>Phone Number</span>
            <span>{{ formData.contact_phone }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span>{{ formData.contact_email }}</span>
            <email-tooltip :email="formData.contact_email"></email-tooltip>
          </div>
        </div>

        <div class="table-box">
          <div class="title">
            <span>Audit</span>
          </div>
          <div class="tr">
            <span>Referred By</span>
            <span v-if="typeof formData.referrer_nm === 'string' && formData.referrer_nm.trim()">
              <a
                class="name"
                @click="handleToCustomer">
                {{ formData.referrer_nm }}
              </a>
            </span>
            <span v-else>
              <a
                v-if="formData.referrer_user_id"
                class="unname"
                @click="handleToCustomer">Unnamed Account</a>
            </span>
          </div>
          <div class="tr">
            <span>Terms and Conditions</span>
            <span>{{ formData.terms_confirm_date }}</span>
          </div>
          <div class="tr">
            <span>Referral Agreement</span>
            <span>{{ formData.terms_confirm_date }}</span>
          </div>
          <div class="tr">
            <span>Created By</span>
            <span>{{ formData.cs_name }}</span>
          </div>
        </div>


        <div class="table-box">
          <div class="title">
            <span>Bank Account</span>
          </div>

          <div class="tr">
            <span>Bank</span>
            <span>{{ bankName }}</span>
          </div>
          <div class="tr">
            <span>Bank Account Holder's Name</span>
            <span>{{ formData.bank_holder }}</span>
          </div>
          <div class="tr">
            <span>Bank Account Number</span>
            <span>{{ formData.bank_number }}</span>
          </div>
        </div>

      </div>
    </section>

    <section
      v-if="showEdit"
      class="edit-profile">
      <profile-edit-form
        :formDataLock="formDataLock"
        :form="formData"
        :detail="detail"
        :customerId="customerId"
        @changeEmail="handleEmailData"
        @cancel="editHandleCancel"></profile-edit-form>
    </section>

    <!-- <v-dialog
      v-model="editDialog"
      width="900px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h3>Edit Account</h3>
        </div>
        <div class="dialog-body">
          <div class="form-card">
            <div class="form-left">
              <account-form
                ref="base-info"
                :edit="true"
                :formDataLock="formDataLock"
                :form="editForm"
                @getFormData="getSubFormData"
                @changeEmail="handleEmailData"
              />
            </div>
            <div class="form-right">
              <address-form
                ref="address-info"
                :formDataLock="formDataLock"
                :form="editForm"
                :edit="true"
                :is-rules="false"
                @getFormData="getSubFormData"
              />
              <div>
                <span class="title">Password</span>
                <v-button
                  type="primary"
                  plain
                  @click="handlerPassword">Send Password Reset Link to {{formData.identity === 1 ? 'SMS' : 'Email'}}</v-button>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <v-button @click="editDialog = false">Cancel</v-button>
          <v-button
            type="primary"
            @click="handlerSave">Save </v-button>
        </div>
      </div>
    </v-dialog> -->
    <send-email-sms
      ref="send-email-sms"
      :form="form"
      :skip="false"
      :is-edit="true"
      :initContent="detail.reset_url_data"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @send="handlerSend" />
    <link-account-email
      ref="link-email"
      :email="formData.email"
      :companies="formData.attached_accounts"
      :customerId="customerId"
      @refresh="handleRefresh"
    ></link-account-email>
    <enter-email-dialog
      ref="login-email"
      :changeType="emailData.type"
      :isChange="isChange"
      :isUnlink="isUnlink"
      :form="emailData"
      @cancel="handleCancel"
      @changeOk="handleResend"
    ></enter-email-dialog>
    <edit-email-dialog
      ref="edit-email"
      :email="formData.email"
      :companies="formData.attached_accounts"
      :customerId="customerId"
      @openDialog="handleOpenDialog"></edit-email-dialog>
    <send-verification
      ref="send-verfication"
      :email="formData.draft_email"
      @sendVerify="sendVerify"></send-verification>
    <ali-unlink
      ref="ali-unlink"
      :ali_id="formData.ali_open_id"
      @update="handleUpdate"></ali-unlink>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import ProfileEditForm from './form/profile-edit-form'
import {editAccount, multiCompanyResend, resendEmailApprove, sendPasswordRestList, draftEmailCancel} from '@api/account'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {editEmailDialog, enterEmailDialog, linkAccountEmail} from '../components/emailAccount'
import sendVerification from './popup/send-verification.vue'
import aliUnlink from './popup/ali-unlink.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'profileTab',
  components: {
    ProfileEditForm,
    SendEmailSms,
    linkAccountEmail,
    enterEmailDialog,
    editEmailDialog,
    sendVerification,
    aliUnlink
  },
  mixins: [MixinOptions],
  props: {
    // form: {
    //   type: Object,
    //   default: () => ({}),
    // },
    // detail: {
    //   type: Object,
    //   default: () => ({}),
    // },
  },
  inject:['detailData'],
  data() {
    return {
      editDialog: false,
      isChange: false,
      formData: {},
      editForm: {},
      subForm: {
        'base-info': false,
        'address-info': false,
      },
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      banks:[],
      emailData:{},
      changeType:1,
      isUnlink:false,
      isResetTip:false,
      showInfo: true,
      showEdit: false,
      seconds: 60,
      sendBtnDisabled: false,
      timer: null
    }
  },
  computed: {
    ...mapState('common', ['bankList']),
    detail(){
      return this.detailData()
    },
    form(){
      return this.detailData().customer_profile
    },
    emailTitle(){
      return this.detail.reset_url_title || ''
    },
    emailListTitle(){
      return this.detail.reset_url_list_title || ''
    },
    customerId(){
      return this.$route.query.customer_id||''
    },
    address() {
      const arr = [
        this.formData.addr_room?`ROOM ${this.formData.addr_room}`:'',
        this.formData.addr_floor?`${this.formData.addr_floor}/F`:'',
        this.formData.addr_block?`BLOCK ${this.formData.addr_block}`:'',
        this.formData.addr_building,
        this.formData.addr_street,
        this.getAreaName('district', this.formData.addr_district),
        this.getAreaName('area', this.formData.addr_area),
        this.getAreaName('region', this.formData.addr_region),
      ]
      return arr.filter((item) => item).join(' ')
    },
    photoUrl() {
      return function(val){
        if (this.formData.id_type_pic){
          if(val == 'url'){
            return this.formData.id_type_pic.url
          }else{
            return this.formData.id_type_pic.thumb_url || ''
          }
        }
      }
    },
    isVerified() {
      // return this.formData.verified == 1
      return this.form.verified > 0
    },
    bankName() {
      let result = {}
      this.bankList.some((item) => {
        if (item.bank_code == this.formData.bank_code) {
          result = item
          return true
        }
        return false
      })
      return result.bank_name
    },
    showReviewIdentification() {
      const { id_type_pic, status } = this.form
      return !this.isVerified || !id_type_pic || status == 2
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
      },
    },
    '$route':{
      immediate: true,
      deep: true,
      handler(val){
        if(val.params && val.params.edit){
          this.handlerEdit()
        }
      }
    }
  },
  created() {
    this.getBankList()
  },
  methods: {
    ...mapActions('common', ['getBankList']),
    handleToCustomer(){
      this.$router.push ({
        path:'/accounts/detail',
        query:{
          customer_id: this.formData.referrer_user_id
        }
      })
    },
    handleToHD(){
      this.$emit('changeTab', 'hdTab')
    },
    handleCancel(){
      // this.$refs['login-email'].handleClose()
      this.$refs['edit-email'].handleShow()
    },
    sendVerification(){
      this.$refs['send-verfication'].changeDialog()
    },
    draftEmailCancel(){
      this.network().draftEmailCancel()
    },
    handleResend(email){
      this.formData.attached_change_account = email||''
    },
    handleMultiSend(){
      this.network().multiCompanyResend()
    },
    handleOpenDialog(type){
      if(type==1){
        this.isUnlink = false
        this.isChange = true
      }else{
        this.isChange= false
        this.isUnlink = true
      }
      this.$refs['login-email'].handleShow()
    },
    handleEmailData(data){
      this.emailData = data
      this.isUnlink= false
      this.isChange= false
      let { type} = data||{}
      if(type==1)
        this.$refs['login-email'].handleShow()
      else{
        this.$refs['edit-email'].handleShow()
      }
    },
    handleRefresh(){
      this.$emit('refresh')
    },
    handleShowEmail(){
      this.$refs['link-email'].handleShow()
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.editForm = Object.assign(this.editForm, data)
    },
    handlerEdit() {
      this.formDataLock += 1
      this.editForm = JSON.parse(JSON.stringify(this.formData))
      // this.editDialog = true
      this.showInfo = false
      this.showEdit = true
    },
    editHandleCancel(){
      this.showInfo = true
      this.showEdit = false
    },
    handlerSave() {
      Object.keys(this.subForm).some((key) => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some((item) => item === false)) {
        return
      }
      this.network().editAccount()
    },
    handlerPassword (id){
      // this.network().sendPasswordRestList()
      if(this.formData.attached_account)
        this.$NewMessageDialog({
          dialogData: { title:'Linked Account'},
          message: 'This account’s login credentials is linked. This will reset the password for all linked accounts. Continue?',
        }).then(()=>{
          this.$refs['send-email-sms'].changeDialog()
        })
      else{
        this.$refs['send-email-sms'].changeDialog()
      }
    },
    handlerSend(content) {
      this.network().sendPasswordRestList(content)
    },
    handleUpdate(){
      this.$emit('update')
    },

    sendVerify(){
      this.seconds = 60
      this.sendBtnDisabled = true
      if(this.timer){
        clearInterval(this.timer)
      }
      this.timer = null
      this.timer = setInterval(() => {
        this.seconds --
        if(this.seconds === 0){
          clearInterval(this.timer)
          this.timer = null
          this.sendBtnDisabled = false
        }
      },1000)
    },
    handleUnlink(){
      this.$refs['ali-unlink'].changeDialog()
    },
    network() {
      return {
        editAccount: async () => {
          const { data } = await editAccount(this.editForm)

          this.$message({
            type: 'success',
            message: 'Success',
          })
          this.editDialog = false
          this.formData = Object.assign(this.formData, this.editForm)
          this.$parent.network().getAccountDetail()
          // this.$emit(
          //   'editProfile',this.formData
          // )
        },
        resendEmailApprove: async () => {
          const { data } = await resendEmailApprove({
            user_id: this.$route.query.customer_id,
          })

          this.$message({
            type: 'success',
            message: 'Success',
          })
        },
        sendPasswordRestList: async (content) => {
          const { data,status } = await sendPasswordRestList({
            customer_id:this.form.id,
            content
          })
          //data.message/data.message_lang
          if (status == 200)
          {
            // this.$message({
            //   type: 'success',
            //   message: 'Success'
            // })
            this.$refs['send-email-sms'].changeDialog()
            this.$NewMessageDialog({
              dialogData: {title:'Link Sent'},
              message: 'The reset password link has been sent.',
              isUnitButton:true,
              unitText:'OK',
              isPlain:true
            }).then(()=>{
              // this.$emit('save')
            })
          }
        },
        multiCompanyResend: async (content) => {
          const { data,status } = await multiCompanyResend({
            customer_id:this.$route.query.customer_id,
          })
          if (status == 200)
          {
            this.$message({
              type: 'success',
              message: 'Success'
            })
          }
        },
        draftEmailCancel: async () => {
          const {data} = await draftEmailCancel({
            user_id: this.customerId
          })
          if(data.code === 1000){
            this.$message({
              type: 'success',
              message: 'Success',
            })
            this.handleUpdate()
          }
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.profile-tab {
  position: relative;

  .status-container {
    margin: 5px 0 20px;
    .waiting-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
      border: 1px solid rgba(176,136,0,0.2);
      background: #FFFBDD;
      color: #24292E;
      font-size: 14px;
    }
  }

  .table .tr {
    padding: 10px;
  }

  .table-box {
    & + .table-box{
      margin-top: 30px;
    }
    .title{
      width: 100%;
      font-weight: 600;
      font-size: 14px;
      height: 52px;
      background: #F6F8FA;
      border: 1px solid #E1E4E8;
      border-radius: 6px 6px 0px 0px;
      span{
        padding: 16px;
        display: inline-block;
      }
    }
    .hd{
      border-radius: 6px;
      cursor: pointer;
      span{
        padding: 16px 0;
      }
      .title-name{
        padding-left: 16px;
        font-weight: 600;
        font-size: 14px;
        color: #0366D6;
      }
      .money{
        margin: 0 6px;
        padding: 0px 6px;
        height: 16px;
        background: rgba(209, 213, 218, 0.5);
        border-radius: 100px;
        font-weight: 600;
        color: #24292E;
        line-height: 16px;
      }
      .icon{
        font-weight: 900;
        font-size: 16px;
        color: #0366D6;
      }
      .code{
        float: right;
        padding-right: 16px;
        color: #586069;
      }
    }
    .tr {
      display: flex;
      border: 1px solid #D1D5DA;
      border-top: 0;
      padding: 8px 16px;
      span{
        flex: 1;
        &:first-child{
          font-weight: 600;
          font-size: 14px;
          color: #586069;
        }
        &:last-child{
          color: #24292E;
          font-size: 14px;
        }
      }
      .email{
        .icon{
          font-weight: 900;
          font-size: 14px;
          margin-left: 9px;
        }
        .check{
          color: #22863A;
        }
      }

      .column{
        flex-direction: column;
        align-items: start !important;
      }

      .purple{
        color: #6F42C1 !important;
        .icon{
          margin-right: 4px;
        }
      }

      .column-box {
        flex: 1;
        display: flex;
        flex-direction: column;
        .status{
          color: #B08800;
          font-size: 12px;
          font-weight: 600;
          display: inline-block;
          margin-left: 8px;
        }
        .mt-5 + .mt-5{
          margin-top: 5px;
        }
      }
      &:last-child{
        border-radius: 0px 0px 6px 6px;
      }
      .name{
        color: #0366D6 !important;
        cursor: pointer;
        text-decoration: none;
      }
      .unname{
        font-style: italic;
        cursor: pointer;
        color: #6A737D !important;
      }
    }
  }

  .user-info{
    .tr {
      span:last-child{
        display: flex;
        align-items: center;
      }
    }
    .ali_id{
      .unlink{
        margin-left: 10px;
        font-weight: 400 !important;
        font-size: 14px !important;
        color: #CB2431 !important;
        cursor: pointer;
      }
    }
  }

  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
  }

  .top-right {
    position: absolute;
    top: 0;
    right: 0;
    .el-button{
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
      color: #24292E;
      font-weight: 600;
      font-size: 14px;
      font-family: 'Inter';
    }
  }

  .form-card {
    display: flex;
    background: white;
    border-radius: 4px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    .form-left,
    .form-right {
      flex: 1;
    }

    .form-left {
      padding: 20px;
      border-right: 1px solid #dddfe7;
    }

    .form-right {
      padding: 20px;
    }

    .form-block {
      margin-bottom: 15px;

      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        color: #616266;
        font-weight: bold;
        font-size: 14px;
      }
    }

    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }

    .form-flex {
      display: flex;
      justify-content: space-between;

      & > .form-block {
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .dialog-container {
    .dialog-header {
      padding: 15px 15px 0;
    }

    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
    }
  }

  .labelTile {
    color: #616266;
    font-size: 20px;
    margin-bottom: 13px;
    display: block;
    margin-top: 24px;
  }

  .upload-card {
    margin-top: 10px;
    z-index: 0;
    position: relative;
    display: flex;
    //justify-content: center;
    align-items: center;
    width: 250px;
    height: 150px;
    //border: 1px dashed #91939A;
    border-radius: 4px;

    img {
      max-width: 100%;
      max-height: 100%;
      z-index: 3;
    }
  }

  .middle{
    align-items: center;
  }

  .approveStatus {
    background: #e6a23d;
    color: #fff;
    padding: 5px 8px;
    border-radius: 50px;
    margin-left: 5px;
  }

  .check {
    color: #28a745;
    font-size: 12px;
    font-weight: bold;
    margin-left: 8px;
  }

  .sendEmail {
    color: #24292e;
    display: flex;
    align-items: center;
    .button {
      font-size: 12px;
      margin-left: 8px;
    }
  }
  .flex-exist-link{
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #6F42C1;
    span{
      margin-left: 6px;
    }
  }
  .flex-email{
    align-items: center;
    cursor: pointer;
    span{
      margin-right: 6px;
      font-size: 14px;
      font-weight: 400 !important;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #6F42C1 !important;
    }
    .icon-right{
      font-weight: 900;
      font-size: 16px;
      line-height: 20px;
      color: #6F42C1;
    }
  }
  .resend-email{
    margin-top: 4px;
    .italic{
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #24292E !important;
      font-style: italic;
      white-space: nowrap;
    }
    .send-btn{
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
      color: #24292E;
      margin-left: 10px;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
      padding: 5px 12px;
      font-family: inter;
    }
  }
}
.btnList{
  .el-button{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    font-family: 'Inter';
  }
  .send{
    color: #0366D6;
    /deep/.label-name{
      color: inherit !important;
    }
  }
  .second{
    font-size: 12px;
  }
  .gray{
    width: 170px;
    color: #999;
    .label-name{
      padding-right: 3px;
      opacity: 0.5;
    }
  }
  .cancel{
    color: #24292E;
  }
}
</style>
